// FILES IN AN AI ANSWER — the `files-recent` view (functions/filesAnswer.js
// filesAiViews; the shell mounts it in the assistant's thread and on a Fly
// page with scope { params, embedded }). Read-only. Its items live in its OWN
// state (never root.fileNodes), read once per params: the home widget kit's
// rows — the name, "kind · when", an icon by kind; a row opens the item in the
// Files window. While reading: three row stand-ins; no match or a failed read:
// one sentence.
export const FilesAnswerView = {
  flow: 'y',
  gap: 'A',
  minWidth: '0',
  dataFilesAnswer: true,
  state: { files: null, failed: false },
  // EMPTY (the views contract, workspace functions/assistantAppViews.js): the
  // read answered with no item — the one sentence is all the view shows, and
  // a Fly page gives its card one row. null while reading.
  empty: (el, s) => (Array.isArray(s.files) ? s.files.length === 0 : null),
  onRender: (el) => el.call('filesAnswerLoad', el),

  FilesAnswerSkeleton: {
    flow: 'y',
    gap: 'Y',
    ariaBusy: 'true',
    hide: (el, s) => Array.isArray(s.files),
    Skeleton_1: { height: 'B', round: 'radiusControl' },
    Skeleton_2: { height: 'B', round: 'radiusControl' },
    Skeleton_3: { height: 'B', round: 'radiusControl', width: '60%' }
  },

  FilesAnswerNote: {
    tag: 'p',
    margin: '0',
    fontSize: 'Z',
    color: 'caption',
    hide: (el, s) => !Array.isArray(s.files) || s.files.length > 0,
    text: (el, s) => {
      void s.root.lang
      return el.call('polyglot', s.failed ? 'files.answer.failed' : 'files.answer.empty')
    }
  },

  FilesAnswerList: {
    flow: 'y',
    gap: 'Y',
    minWidth: '0',
    hide: (el, s) => !Array.isArray(s.files) || !s.files.length,
    childExtends: 'HomeWidgetRow',
    childrenAs: 'state',
    children: (el, s) => {
      void s.root.lang
      return el.call('filesAnswerRows', s.files)
    }
  }
}
